import { sum, toChartData } from '../../util/helper';
import { default as initialState } from './state';
import NOT_PUSHED_REASONS from 'src/resources/not_pushed_reasons.hjson';

const $leadPriceRangeSeries = [
	0, 0, 0, 0, 0, 0,
];

const $leadPriceRangeLabels = [
	'bis 2.500€',
	'von 2.500€ bis 5.000€',
	'von 5.000€ bis 10.000€',
	'von 10.000€ bis 15.000€',
	'von 15.000€ bis 20.000€',
	'ab 20.000',
];

export function INIT(state) {
	state.init = true;
}

export function SET_LOADING(state, isLoading) {
	state.loading = isLoading;
}

function toPriceRange(data) {
	if (data.length < 1) {
		return { series: [], labels: [] };
	}

	const leadPriceRangeLabels = [...$leadPriceRangeLabels];
	const leadPriceRangeSeries = [...$leadPriceRangeSeries];

	for (let i = 0; i < data.length; i++) {
		const price = data[i].price;
		if (price <= 2500) {
			leadPriceRangeSeries[0] += 1;
		}
		if (price > 2500 && price <= 5000) {
			leadPriceRangeSeries[1] += 1;
		}
		if (price > 5000 && price <= 10000) {
			leadPriceRangeSeries[2] += 1;
		}
		if (price > 10000 && price <= 15000) {
			leadPriceRangeSeries[3] += 1;
		}
		if (price > 15000 && price <= 20000) {
			leadPriceRangeSeries[4] += 1;
		}
		if (price > 20000) {
			leadPriceRangeSeries[5] += 1;
		}
	}

	return { series: leadPriceRangeSeries, labels: leadPriceRangeLabels };
}

function groupBy(data, key) {
	const grouped = data.reduce(function(storage, item) {
		let group = item[key];
		storage[group] = storage[group] || [];
		storage[group].push(item);

		return storage;
	}, {});

	const chartData = Object.entries(grouped).map(item => ({
		x: item[0],
		y: item[1].length,
	}));

	return chartData.sort((a, b) => b.y - a.y);
}

function countErrors(data) {
	const arrayOfErrors = data.map(obj => obj.uploadErrors).flat(1);
	const counted = arrayOfErrors.reduce(
		(prev, curr) => prev.set(curr, (prev.get(curr) || 0) + 1),
		new Map(),
	);

	return {
		labels: [...counted.keys()].map(errId => NOT_PUSHED_REASONS[errId]),
		series: [...counted.values()],
	};
}

// listings
export function SET_LISTINGS(state, listings) {
	state.listingViewsSum = sum(listings, 'listing_views');
	state.listingViewsChart = toChartData(listings, 'listing_views'),

	state.mailLeadsSum = sum(listings, 'marketplace_leads');
	state.mailLeadsChart = toChartData(listings, 'marketplace_leads');

	state.chatLeadsSum = sum(listings, 'initial_marketplace_messages');
	state.chatLeadsChart = toChartData(listings, 'initial_marketplace_messages');

	state.phoneCallClicks = sum(listings, 'phone_call_clicks');
}

// vehicles
export function SET_VEHICLESTATS(state, { vehicleCount, vehicleErrors }) {
	state.vehicleCountCurrent = vehicleCount.length && vehicleCount[vehicleCount.length - 1].vehicleCount || 0;
	state.vehicleCountChart = toChartData(vehicleCount, 'vehicleCount');
	state.vehicleErrorSum = vehicleErrors.length;
	state.vehicleErrorChart = countErrors(vehicleErrors);
}

// lead
export function SET_LEADSTATS(state, data) {
	state.pricePieChart = toPriceRange(data.vehicleLeads);
	state.leadMakeChart = groupBy(data.vehicleLeads, 'make');
}

// filter
export function SET_FILTER_DATERANGE(state, { max }) {
	state.maxDate = max;
}

export function SET_FILTER(state, filter) {
	Object.assign(state.filter, filter);
}

export function UPDATE_FILTER(state, filter) {
	Object.assign(state.filter, filter);
}

export function RESET_FILTER(state) {
	state.filter = initialState().filter;
}
